import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Campaign Settings", -1);
var _hoisted_2 = {
  "class": "flex items-center justify-between mb-6"
};
var _hoisted_3 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Tenant")])], -1);
var _hoisted_5 = {
  "class": "flex justify-between pb-2 w-full"
};
var _hoisted_6 = {
  "class": "px-2"
};
var _hoisted_7 = {
  "class": "px-2"
};
var _hoisted_8 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_9 = {
  "class": "flex items-center px-1 py-1"
};
var _hoisted_10 = {
  "class": "flex items-center px-1 py-1"
};
var _hoisted_11 = {
  "class": "flex items-center px-1 py-1"
};
var _hoisted_12 = {
  "class": "flex items-center px-1 py-4"
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = {
  "class": "flex justify-end"
};
var _hoisted_15 = {
  "class": "m-4"
};
var _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", {
  "class": "text-center capitalize"
}, "Campaign Settings", -1);
var _hoisted_17 = {
  "class": "rounded-lg w-full mx-auto bg-white p-6 overflow-y-scroll",
  style: {
    "max-height": "500px"
  }
};
var _hoisted_18 = {
  key: 0,
  "class": "flex justify-between items-center px-4 py-2 w-full"
};
var _hoisted_19 = /*#__PURE__*/_createElementVNode("h6", {
  "class": "text-sm font-bold"
}, "Campaign Settings", -1);
var _hoisted_20 = [_hoisted_19];
var _hoisted_21 = {
  "class": "py-3"
};
var _hoisted_22 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Email Type (Auto Draft)", -1);
var _hoisted_24 = {
  "class": "flex items-center justify-center gap-2 w-1/7"
};
var _hoisted_25 = /*#__PURE__*/_createTextVNode("Automatic");
var _hoisted_26 = /*#__PURE__*/_createTextVNode("Manual");
var _hoisted_27 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_28 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Follow Up Start Time", -1);
var _hoisted_29 = {
  "class": "flex items-center justify-center gap-2 w-1/7"
};
var _hoisted_30 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Follow Up End Time", -1);
var _hoisted_32 = {
  "class": "flex items-center justify-center gap-2 w-1/7"
};
var _hoisted_33 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_34 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Maximum number of people to be contacted per company in a day", -1);
var _hoisted_35 = {
  "class": "flex items-center justify-center gap-2 w-1/7"
};
var _hoisted_36 = /*#__PURE__*/_createElementVNode("option", {
  value: 1
}, "1", -1);
var _hoisted_37 = /*#__PURE__*/_createElementVNode("option", {
  value: 2
}, "2", -1);
var _hoisted_38 = /*#__PURE__*/_createElementVNode("option", {
  value: 3
}, "3", -1);
var _hoisted_39 = /*#__PURE__*/_createElementVNode("option", {
  value: 4
}, "4", -1);
var _hoisted_40 = /*#__PURE__*/_createElementVNode("option", {
  value: 5
}, "5", -1);
var _hoisted_41 = /*#__PURE__*/_createElementVNode("option", {
  value: 6
}, "6", -1);
var _hoisted_42 = /*#__PURE__*/_createElementVNode("option", {
  value: 7
}, "7", -1);
var _hoisted_43 = /*#__PURE__*/_createElementVNode("option", {
  value: 8
}, "8", -1);
var _hoisted_44 = /*#__PURE__*/_createElementVNode("option", {
  value: 9
}, "9", -1);
var _hoisted_45 = /*#__PURE__*/_createElementVNode("option", {
  value: 10
}, "10", -1);
var _hoisted_46 = /*#__PURE__*/_createElementVNode("option", {
  value: 11
}, "11", -1);
var _hoisted_47 = /*#__PURE__*/_createElementVNode("option", {
  value: 12
}, "12", -1);
var _hoisted_48 = [_hoisted_36, _hoisted_37, _hoisted_38, _hoisted_39, _hoisted_40, _hoisted_41, _hoisted_42, _hoisted_43, _hoisted_44, _hoisted_45, _hoisted_46, _hoisted_47];
var _hoisted_49 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_50 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Maximum number of emails to be sent per campaigner per min", -1);
var _hoisted_51 = {
  "class": "flex items-center justify-center gap-2 w-1/7"
};
var _hoisted_52 = /*#__PURE__*/_createElementVNode("option", {
  value: 1
}, "1", -1);
var _hoisted_53 = /*#__PURE__*/_createElementVNode("option", {
  value: 2
}, "2", -1);
var _hoisted_54 = /*#__PURE__*/_createElementVNode("option", {
  value: 3
}, "3", -1);
var _hoisted_55 = /*#__PURE__*/_createElementVNode("option", {
  value: 4
}, "4", -1);
var _hoisted_56 = /*#__PURE__*/_createElementVNode("option", {
  value: 5
}, "5", -1);
var _hoisted_57 = /*#__PURE__*/_createElementVNode("option", {
  value: 6
}, "6", -1);
var _hoisted_58 = /*#__PURE__*/_createElementVNode("option", {
  value: 7
}, "7", -1);
var _hoisted_59 = /*#__PURE__*/_createElementVNode("option", {
  value: 8
}, "8", -1);
var _hoisted_60 = /*#__PURE__*/_createElementVNode("option", {
  value: 9
}, "9", -1);
var _hoisted_61 = /*#__PURE__*/_createElementVNode("option", {
  value: 10
}, "10", -1);
var _hoisted_62 = /*#__PURE__*/_createElementVNode("option", {
  value: 11
}, "11", -1);
var _hoisted_63 = /*#__PURE__*/_createElementVNode("option", {
  value: 12
}, "12", -1);
var _hoisted_64 = [_hoisted_52, _hoisted_53, _hoisted_54, _hoisted_55, _hoisted_56, _hoisted_57, _hoisted_58, _hoisted_59, _hoisted_60, _hoisted_61, _hoisted_62, _hoisted_63];
var _hoisted_65 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_66 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Maximum fresh contacts to be reached out per campaigner per day", -1);
var _hoisted_67 = {
  "class": "flex items-center justify-center gap-2 w-1/7"
};
var _hoisted_68 = /*#__PURE__*/_createElementVNode("option", {
  value: 50
}, "50", -1);
var _hoisted_69 = /*#__PURE__*/_createElementVNode("option", {
  value: 100
}, "100", -1);
var _hoisted_70 = /*#__PURE__*/_createElementVNode("option", {
  value: 150
}, "150", -1);
var _hoisted_71 = /*#__PURE__*/_createElementVNode("option", {
  value: 200
}, "200", -1);
var _hoisted_72 = /*#__PURE__*/_createElementVNode("option", {
  value: 300
}, "300", -1);
var _hoisted_73 = /*#__PURE__*/_createElementVNode("option", {
  value: 500
}, "500", -1);
var _hoisted_74 = [_hoisted_68, _hoisted_69, _hoisted_70, _hoisted_71, _hoisted_72, _hoisted_73];
var _hoisted_75 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_76 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Maximum emails to be sent per campaigner per day", -1);
var _hoisted_77 = {
  "class": "flex items-center justify-center gap-2 w-1/7"
};
var _hoisted_78 = /*#__PURE__*/_createElementVNode("option", {
  value: 250
}, "250", -1);
var _hoisted_79 = /*#__PURE__*/_createElementVNode("option", {
  value: 500
}, "500", -1);
var _hoisted_80 = /*#__PURE__*/_createElementVNode("option", {
  value: 750
}, "750", -1);
var _hoisted_81 = /*#__PURE__*/_createElementVNode("option", {
  value: 1000
}, "1000", -1);
var _hoisted_82 = /*#__PURE__*/_createElementVNode("option", {
  value: 1500
}, "1500", -1);
var _hoisted_83 = /*#__PURE__*/_createElementVNode("option", {
  value: 2000
}, "2000", -1);
var _hoisted_84 = /*#__PURE__*/_createElementVNode("option", {
  value: 2500
}, "2500", -1);
var _hoisted_85 = [_hoisted_78, _hoisted_79, _hoisted_80, _hoisted_81, _hoisted_82, _hoisted_83, _hoisted_84];
var _hoisted_86 = {
  key: 1,
  "class": "flex justify-between items-center px-4 py-2 w-full"
};
var _hoisted_87 = /*#__PURE__*/_createElementVNode("h6", {
  "class": "text-sm font-bold"
}, "Follow Up Intervals", -1);
var _hoisted_88 = [_hoisted_87];
var _hoisted_89 = {
  key: 2
};
var _hoisted_90 = {
  "class": "py-3"
};
var _hoisted_91 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_92 = {
  "class": "text-sm"
};
var _hoisted_93 = {
  "class": "flex items-center justify-center gap-2 w-1/7"
};
var _hoisted_94 = ["onUpdate:modelValue"];
var _hoisted_95 = /*#__PURE__*/_createElementVNode("option", {
  value: 0
}, "Same", -1);
var _hoisted_96 = /*#__PURE__*/_createElementVNode("option", {
  value: 1
}, "1", -1);
var _hoisted_97 = /*#__PURE__*/_createElementVNode("option", {
  value: 2
}, "2", -1);
var _hoisted_98 = /*#__PURE__*/_createElementVNode("option", {
  value: 3
}, "3", -1);
var _hoisted_99 = /*#__PURE__*/_createElementVNode("option", {
  value: 4
}, "4", -1);
var _hoisted_100 = /*#__PURE__*/_createElementVNode("option", {
  value: 5
}, "5", -1);
var _hoisted_101 = /*#__PURE__*/_createElementVNode("option", {
  value: 6
}, "6", -1);
var _hoisted_102 = /*#__PURE__*/_createElementVNode("option", {
  value: 7
}, "7", -1);
var _hoisted_103 = /*#__PURE__*/_createElementVNode("option", {
  value: 8
}, "8", -1);
var _hoisted_104 = /*#__PURE__*/_createElementVNode("option", {
  value: 9
}, "9", -1);
var _hoisted_105 = /*#__PURE__*/_createElementVNode("option", {
  value: 10
}, "10", -1);
var _hoisted_106 = [_hoisted_95, _hoisted_96, _hoisted_97, _hoisted_98, _hoisted_99, _hoisted_100, _hoisted_101, _hoisted_102, _hoisted_103, _hoisted_104, _hoisted_105];
var _hoisted_107 = {
  "class": "w-full flex justify-center items-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_el_pagination = _resolveComponent("el-pagination");
  var _component_el_time_select = _resolveComponent("el-time-select");
  var _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_Head, {
    title: "Campaign Settings"
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("table", _hoisted_3, [_hoisted_4, _createElementVNode("tr", _hoisted_5, [_createElementVNode("td", _hoisted_6, [_createVNode(_component_el_select, {
    modelValue: $data.tenantId,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.tenantId = $event;
    }),
    filterable: "",
    onChange: _cache[1] || (_cache[1] = function ($event) {
      return $options.getCampaigns(true);
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenatList, function (tenant, tenant_key) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: tenant.id,
          label: tenant.tenant_name
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("td", _hoisted_7, [_createElementVNode("button", {
    "class": "text-white focus:text-indigo-500 text-sm bg-indigo-800 p-2 rounded-md",
    type: "button",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.navigateToBulkUpdate && $options.navigateToBulkUpdate.apply($options, arguments);
    })
  }, "Bulk settings")])])])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingCampaigns,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table, {
        data: $data.campaignList,
        style: {
          "width": "100%"
        }
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "id",
            label: "ID",
            fixed: "left"
          }), _createVNode(_component_el_table_column, {
            label: "Campaign Details",
            fixed: "left",
            width: "350"
          }, {
            "default": _withCtx(function (scope) {
              return [_createElementVNode("div", _hoisted_9, _toDisplayString(scope.row.name), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(scope.row.campaigner), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(scope.row.sudo_email), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "companies_count",
            label: "Total Companies",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "contacts_count",
            label: "Total Contacts",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "emails_per_day",
            label: "FreshContacts/day",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "emails_per_day_total",
            label: "Emails/day",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "contacts_per_company",
            label: "People/Company",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            prop: "emails_per_minute",
            label: "Emails/Minute",
            width: "150"
          }), _createVNode(_component_el_table_column, {
            label: "Status",
            width: "150"
          }, {
            "default": _withCtx(function (scope) {
              return [_createElementVNode("div", {
                "class": _normalizeClass($options.getCampaignStatusClass(scope.row.status))
              }, _toDisplayString(scope.row.status), 3)];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "launch_date",
            label: "Launch Date",
            width: "200"
          }), _createVNode(_component_el_table_column, {
            label: "Change Settings",
            fixed: "right",
            width: "150"
          }, {
            "default": _withCtx(function (scope) {
              return [_createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
                "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 p-2 rounded-md",
                type: "button",
                onClick: function onClick($event) {
                  return $options.showCampaignSettings(scope.row);
                }
              }, "Edit", 8, _hoisted_13)])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data"])];
    }),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingPaginate,
    animated: "",
    count: 1
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        total: $data.totalCount,
        "current-page": $data.currentPage,
        onCurrentChange: $options.pageChange
      }, null, 8, ["total", "current-page", "onCurrentChange"])];
    }),
    _: 1
  }, 8, ["loading"])])])])]), _createVNode(_component_el_dialog, {
    modelValue: $data.showSettings,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
      return $data.showSettings = $event;
    }),
    top: "5vh",
    center: ""
  }, {
    header: _withCtx(function () {
      return [_hoisted_16];
    }),
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_17, [$data.campaignSettings.follow_interval.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20)) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createVNode(_component_el_select, {
        "class": "w-32 text-gray-900 sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 p-2",
        modelValue: $data.campaignSettings.emailType,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return $data.campaignSettings.emailType = $event;
        })
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_option, {
            value: "automatic"
          }, {
            "default": _withCtx(function () {
              return [_hoisted_25];
            }),
            _: 1
          }), _createVNode(_component_el_option, {
            value: "manual"
          }, {
            "default": _withCtx(function () {
              return [_hoisted_26];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_time_select, {
        "class": "w-32",
        modelValue: $data.campaignSettings.follow_up_time,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return $data.campaignSettings.follow_up_time = $event;
        }),
        "max-time": $data.campaignSettings.follow_up_end_time,
        start: "00:00",
        step: "00:30",
        end: "23:59",
        placeholder: "Not Applicanble",
        format: "HH:mm",
        "value-format": "HH:mm:ss"
      }, null, 8, ["modelValue", "max-time"])])]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [_createVNode(_component_el_time_select, {
        "class": "w-32",
        modelValue: $data.campaignSettings.follow_up_end_time,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return $data.campaignSettings.follow_up_end_time = $event;
        }),
        "min-time": $data.campaignSettings.follow_up_time,
        start: "00:00",
        step: "00:30",
        end: "23:59",
        placeholder: "Not Applicanble",
        format: "HH:mm",
        "value-format": "HH:mm:ss"
      }, null, 8, ["modelValue", "min-time"])])]), _createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("div", _hoisted_35, [_withDirectives(_createElementVNode("select", {
        "class": "w-20 text-gray-900 sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 p-2",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return $data.campaignSettings.contactsPerCompany = $event;
        })
      }, _hoisted_48, 512), [[_vModelSelect, $data.campaignSettings.contactsPerCompany]])])]), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, [_withDirectives(_createElementVNode("select", {
        "class": "w-20 text-gray-900 sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 p-2",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
          return $data.campaignSettings.emailsPerMinute = $event;
        })
      }, _hoisted_64, 512), [[_vModelSelect, $data.campaignSettings.emailsPerMinute]])])]), _createElementVNode("div", _hoisted_65, [_hoisted_66, _createElementVNode("div", _hoisted_67, [_withDirectives(_createElementVNode("select", {
        "class": "w-20 text-gray-900 sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 p-2",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
          return $data.campaignSettings.emailsPerDay = $event;
        })
      }, _hoisted_74, 512), [[_vModelSelect, $data.campaignSettings.emailsPerDay]])])]), _createElementVNode("div", _hoisted_75, [_hoisted_76, _createElementVNode("div", _hoisted_77, [_withDirectives(_createElementVNode("select", {
        "class": "w-20 text-gray-900 sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 p-2",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return $data.campaignSettings.emailsPerDayTotal = $event;
        })
      }, _hoisted_85, 512), [[_vModelSelect, $data.campaignSettings.emailsPerDayTotal]])])])])]), $data.campaignSettings.follow_interval.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_86, _hoisted_88)) : _createCommentVNode("", true), $data.campaignSettings.follow_interval.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.campaignSettings.follow_interval, function (fp) {
        return _openBlock(), _createElementBlock("div", _hoisted_91, [_createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.$helpers.stringifyNumber(fp.follow_up_order)), 1), _createElementVNode("div", _hoisted_93, [_withDirectives(_createElementVNode("select", {
          "class": "w-20 text-gray-900 sm:text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 p-2",
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return fp.interval = $event;
          }
        }, _hoisted_106, 8, _hoisted_94), [[_vModelSelect, fp.interval]])])]);
      }), 256))])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_107, [_createElementVNode("button", {
        "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 p-2 rounded-md",
        onClick: _cache[10] || (_cache[10] = function () {
          return $options.resetCampaignSettings && $options.resetCampaignSettings.apply($options, arguments);
        })
      }, "Discard Changes"), _createElementVNode("button", {
        "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 p-2 rounded-md",
        onClick: _cache[11] || (_cache[11] = function () {
          return $options.saveCampaignSettings && $options.saveCampaignSettings.apply($options, arguments);
        })
      }, "Save Changes")])];
    }),
    _: 1
  }, 8, ["modelValue"])], 64);
}